/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Fields whose current values are placeholders and should be rendered as unconfirmed in the UI.
 * @export
 */
export const PlaceholderField = {
    FirstName: 'first_name',
    LastName: 'last_name',
} as const;
export type PlaceholderField = typeof PlaceholderField[keyof typeof PlaceholderField];


export function instanceOfPlaceholderField(value: any): boolean {
    for (const key in PlaceholderField) {
        if (Object.prototype.hasOwnProperty.call(PlaceholderField, key)) {
            if (PlaceholderField[key as keyof typeof PlaceholderField] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlaceholderFieldFromJSON(json: any): PlaceholderField {
    return PlaceholderFieldFromJSONTyped(json, false);
}

export function PlaceholderFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaceholderField {
    return json as PlaceholderField;
}

export function PlaceholderFieldToJSON(value?: PlaceholderField | null): any {
    return value as any;
}

export function PlaceholderFieldToJSONTyped(value: any, ignoreDiscriminator: boolean): PlaceholderField {
    return value as PlaceholderField;
}

